import { Component, Input, OnInit, ViewChild } from '@angular/core';
import { DxiItemComponent } from 'devextreme-angular/ui/nested';
import { NicaAnagraficaComponent } from '../nica-anagrafica/nica-anagrafica.component';




@Component({
  selector: 'app-posizioni',
  templateUrl: './posizioni.component.html',
  styleUrls: ['./posizioni.component.css']
})
export class PosizioniComponent implements OnInit {
  @ViewChild('uPosizioni', { static: true }) uPosizione: NicaAnagraficaComponent;
  @Input() itemData: any

  myFilterStr: any="";
  idTabRif: number;
  nomeTabRif: any;
  dati: any;

  constructor() { }

  disbleField(element){ //classe combo box
      var i = $("."+element +" .dx-field-item-required-mark"); 
      i.hide();
      var i = $("."+element+" .dx-texteditor-container"); 
      i.hide();   
      var i = $("."+element +" .dx-field-item-label-text"); 
      i.css("color", "yellow !important"); 
      //console.log("parent ",i);
     

      //      
  }

  SettaForm(){
       //Produttore
       let cIdOperazione=['A1','A2','A3','A4','A5','C1','C2','C3','E2']; 
       let xx =  cIdOperazione.find(x => x == this.dati.idOperazione);
       if(!xx)  this.uPosizione.changeStateField(['idProduttore','idRegistroScarico','idRegistroRentriScarico'],true);
       else this.uPosizione.changeStateField(['idProduttore','idRegistroScarico','idRegistroRentriScarico'],false);
       //Trasportatore
       if(this.dati.trasporto != 'P') this.uPosizione.changeStateField(['idTrasportatore','idRegistroTrasporto','idRegistroRentriTrasporto'],true);
       else this.uPosizione.changeStateField(['idTrasportatore','idRegistroTrasporto','idRegistroRentriTrasporto'],false);   

       //Destinatario
       cIdOperazione=['A5','B1','B2','C3']; 
       xx =  cIdOperazione.find(x => x == this.dati.idOperazione);    
       if(!xx)  this.uPosizione.changeStateField(['idDestinatario','idRegistroCarico','idRegistroRentriCarico'],true);
       else this.uPosizione.changeStateField(['idDestinatario','idRegistroCarico','idRegistroRentriCarico'],false);
       //Intermediario PosizioneCausaleidIntermediario
       if(this.dati.idOperazione != 'D2') this.uPosizione.changeStateField(['idIntermediario','idRegistroIntermediario','idRegistroRentriIntermediario'],true);
       else this.uPosizione.changeStateField(['idIntermediario','idRegistroIntermediario','idRegistroRentriIntermediario'],false);
       // Registro Scarico
       if(this.dati.escludiRegistri){
         this.uPosizione.changeStateField(['idProduttore','idRegistroScarico','idRegistroRentriScarico'],true);
         this.uPosizione.changeStateField(['idDestinatario','idRegistroCarico','idRegistroRentriCarico'],true);   
         this.uPosizione.changeStateField(['idTrasportatore','idRegistroTrasporto','idRegistroRentriTrasporto'],true);
         this.uPosizione.changeStateField(['idIntermediario','idRegistroIntermediario','idRegistroRentriIntermediario'],true);  }
    
  }

  ngOnInit() {
    if (this.itemData) { 
      
      /*this.idTabRif   = this.itemData[0]['idTabRif']
      this.dati       = this.itemData[0]['dati']
      this.myFilterStr = '?idCausale='+this.idTabRif
      console.log("ngOnInit ",this.itemData);
      */
    } 
  }
  onPosizioneSelected(e: any) {
 
  }
  buttonEmitted(em:any){
    //
  }
  onAllEventPosizione(e: any) {
    
    //
    if(e.name=='onEditorPrepared'){
      //console.log("In Posizioni Causali",e)
      // e.data 
      let founds;
      //e.data['registrazioneRegistroRentriIntermediario']="REG00BG";      
      //intemediario      
      founds=this.uPosizione.returnElementsInGriglia(['idRegistroRentriIntermediario']);
      if(founds && e.data['idIntermediario']>0) this.uPosizione.refreshDs(founds[0].prog,e.data['idIntermediario']);
      //Produzione      
      founds=this.uPosizione.returnElementsInGriglia(['idRegistroRentriScarico']);
      if(founds && e.data['idProduttore']>0) this.uPosizione.refreshDs(founds[0].prog,e.data['idProduttore']);
      //Trasporto      
      founds=this.uPosizione.returnElementsInGriglia(['idRegistroRentriTrasporto']);
      if(founds && e.data['idTrasportatore']>0) this.uPosizione.refreshDs(founds[0].prog,e.data['idTrasportatore']);
      //Destinazione      
      founds=this.uPosizione.returnElementsInGriglia(['idRegistroRentriCarico']);
      if(founds && e.data['idDestinatario']>0) this.uPosizione.refreshDs(founds[0].prog,e.data['idDestinatario']);     
      

      this.SettaForm();
    }

    if(e.name=='onEditorPreparing'){
      //var oldData=this.uPosizione.mythis.griglia.instance.getDataSource()._items[0];
      //console.log("OLD DATA ",oldData);
      //alert("fattoxxxxx");
      //e.editorOptions.disabled = true;
      
    }

    if(e.name=='onCellPrepared'){
     // console.log("on cell prepared ",e.rowType);
      //alert("cell prepared");
    }
    //       
//

if (e.name == 'onInitNewRow') {
  console.log("Dati Causale ",this.dati);
  setTimeout(() => {
    //Produttore
    this.SettaForm();
    return;
    let cIdOperazione=['A1','A2','A3','A4','A5','C1','C2','C3','E2']; 
    let xx =  cIdOperazione.find(x => x == this.dati.idOperazione);
    if(!xx)  this.uPosizione.changeStateField(['idProduttore','idRegistroScarico','registrazioneRegistroRentriScarico'],true);
    //Trasportatore
    if(this.dati.trasporto != 'P') this.uPosizione.changeStateField(['idTrasportatore','idRegistroTrasporto','registrazioneRegistroRentriTrasporto'],true);   

    //Destinatario
    cIdOperazione=['A5','B1','B2','C3']; 
    xx =  cIdOperazione.find(x => x == this.dati.idOperazione);    
    if(!xx)  this.uPosizione.changeStateField(['idDestinatario','idRegistroCarico','registrazioneRegistroRentriCarico'],true);   
    //Intermediario PosizioneCausaleidIntermediario
    if(this.dati.idOperazione != 'D2') this.uPosizione.changeStateField(['idIntermediario','idRegistroIntermediario','registrazioneRegistroRentriIntermediario'],true);
    // Registro Scarico
    if(this.dati.escludiRegistri){
      this.uPosizione.changeStateField(['idProduttore','idRegistroScarico','registrazioneRegistroRentriScarico'],true);
      this.uPosizione.changeStateField(['idDestinatario','idRegistroCarico','registrazioneRegistroRentriCarico'],true);   
      this.uPosizione.changeStateField(['idTrasportatore','idRegistroTrasporto','registrazioneRegistroRentriTrasporto'],true);
      this.uPosizione.changeStateField(['idIntermediario','idRegistroIntermediario','registrazioneRegistroRentriIntermediario'],true);  }

  }, 10); 
 

  
}

if (e.name == 'onEditorFieldPreparing') {
  //alert("dddddddddddddddddddd");
  e.editorOptions.disabled=true;
  console.log("In Posizioni Causali onEditorFieldPreparing",e)
}


    if (e.name == ('onSaving')) {
      //alert(this.itemData[0]['nomeTabella']);
     // e.changes[0]['data']['NomeTabella'] = this.nomeTabRif;
      e.changes[0]['data']['idCausale'] = this.idTabRif;
     // console.log("on saving ", e.changes);
    }
  }
  public inizializza(data): void {  
    console.log("Ecco i dati della causale ",this.itemData[0]['dati']) 
    this.idTabRif   = this.itemData[0]['idTabRif']
    this.myFilterStr = '?idCausale='+this.idTabRif
    this.dati       = this.itemData[0]['dati']
    this.uPosizione.refresh();     
  }
}
